import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/da/overspeedanalysisregulation/getpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/da/overspeedanalysisregulation/getdetail/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getClientPage = (params, urlParams) => {
  return axios.request({
    url: '/da/overspeedanalysisregulation/getclientpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const datespeedlimit = (params, urlParams) => {
  return axios.request({
    url: '/da/overspeedanalysisregulation/overspeedanalysisregulation/' + params.terminalNum + '/' + params.speedlimit + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const datevehicleInfoGroupspeedlimit = (params, urlParams) => {
  return axios.request({
    url: '/da/overspeedanalysisregulation/overspeedanalysisregulation/updatevehicleInfoGroupspeedlimit/' + params.vehicleInfoGroupids + '/' + params.speedlimit + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

